/**
 * Calculates the center point of a polygon geometry
 */
export const getPolygonCenterPoint = (polygonGeometry: any) => {
  if (!polygonGeometry || !polygonGeometry.rings || polygonGeometry.rings.length === 0) {
    return null;
  }

  const rings = polygonGeometry.rings[0];
  if (rings.length === 0) {
    return null;
  }

  let sumX = 0;
  let sumY = 0;
  let count = 0;

  for (const ring of rings) {
    if (ring.length >= 2) {
      sumX += ring[0];
      sumY += ring[1];
      count++;
    }
  }

  if (count === 0) {
    return null;
  }

  return {
    x: sumX / count,
    y: sumY / count,
  };
};

/**
 * Creates a polygon geometry object
 */
export const createPolygonGeometry = (rings: number[][], wkid: number = 102100) => {
  return {
    type: "polygon",
    rings: rings,
    spatialReference: {
      wkid: wkid,
    },
  };
};

/**
 * Creates a point geometry object
 */
export const createPointGeometry = (x: number, y: number, wkid: number = 102100) => {
  return {
    type: "point",
    x: x,
    y: y,
    spatialReference: {
      wkid: wkid,
    },
  };
};
